import { BaseForm } from './forms/base-form';

interface AddItemFormProps {
  columnType: 'department' | 'touchpoint' | 'subtouchpoint' | 'title';
  propertyTypeId: string | number;
  onAdd: (data: Record<string, string>) => void;
  onCancel: () => void;
  onSuccess?: () => void;
}

export function AddItemForm({
  columnType,
  propertyTypeId,
  onAdd,
  onSuccess,
}: AddItemFormProps) {
  return (
    <BaseForm
      columnType={columnType}
      propertyTypeId={propertyTypeId}
      onAdd={onAdd}
      onSuccess={onSuccess}
    />
  );
}
